"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SavingsAndPromos_1 = require("./SavingsAndPromos");
exports.default = SavingsAndPromos_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/SavingsAndPromos/index.js
// module id = 782
// module chunks = 8